/**
 * Placeholders shimmer para los estados de carga de listas/drawer.
 * Mantienen las mismas dimensiones que los componentes reales (80px
 * de alto en cards, ~180px de foto en drawer) para que el layout no
 * salte cuando llega la respuesta.
 */

export function PropertyCardSkeleton() {
  return (
    <div className="skeleton-card" aria-hidden="true">
      <div className="sk-photo skeleton" />
      <div className="sk-body">
        <div className="sk-line lg skeleton" />
        <div className="sk-line md skeleton" />
        <div className="sk-line sm skeleton" />
      </div>
    </div>
  );
}

export function ResultsListSkeleton({ count = 6 }: { count?: number }) {
  return (
    <div className="results-grid" aria-hidden="true" role="presentation">
      {Array.from({ length: count }, (_, i) => (
        <PropertyCardSkeleton key={i} />
      ))}
    </div>
  );
}

export function PropertyDetailSkeleton() {
  return (
    <div className="drawer-skeleton" aria-hidden="true">
      <div className="sk-line xl skeleton" />
      <div className="sk-line lg skeleton" />
      <div className="sk-line md skeleton" />
      <div className="sk-photo skeleton" />
      <div className="sk-block skeleton" />
      <div className="sk-block skeleton" />
    </div>
  );
}
